import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgToiletAccessibleinline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 64 64",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		stroke: "currentColor",
		strokeWidth: 2,
		children: [/* @__PURE__ */ _jsx("circle", {
			cx: 25,
			cy: 11,
			r: 4
		}), /* @__PURE__ */ _jsx("path", {
			d: "M54 52l-4.103 1.368a2 2 0 0 1-2.53-1.265l-4.911-14.735A2 2 0 0 0 40.558 36h-11.88a2 2 0 0 1-1.97-1.652L24 19m2 7h10m-16.734 2.145c-4.938 2.86-8.26 8.202-8.26 14.32C11.006 51.596 18.409 59 27.542 59c5.994 0 11.243-3.19 14.143-7.963",
			strokeLinecap: "square",
			strokeLinejoin: "round"
		})]
	})
});
export default SvgToiletAccessibleinline;
